import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by quicksand-bold-label">
      COPYRIGHT {{ date | date : 'yyyy' }} Respond Edu, Inc - ALL RIGHTS
      RESERVED.
    </span>
  `,
})
export class FooterComponent {
  date = new Date();
}
